import client from '../client';

export interface NetSuiteOrder {
  OrderId: number;
  BillToName: string;
  CustomerOrderNo: string;
  ActionName: string;
  CreateDate: string;
  GahhOrderNumber: string | null;
  GahhInvoiceNumber: string | null;
  Total: number;
  Terms: string | null;
}

export interface GahhImportItem {
  OrderId: number;
  GahhOrderNumber: string;
  GahhInvoiceNumber: string;
}

export interface ImportResult {
  success: number;
  failed: number;
}

export const netSuiteInvoicingService = {
  /**
   * Get all orders for NetSuite invoicing
   */
  getOrders: async (): Promise<NetSuiteOrder[]> => {
    const response: any = await client.get('/netsuite-invoicing/orders');
    return response.data;
  },

  /**
   * Import GAHH info from CSV data
   */
  importGahhInfo: async (items: GahhImportItem[]): Promise<ImportResult> => {
    const response: any = await client.post('/netsuite-invoicing/import', { items });
    return response.data;
  },

  /**
   * Update single order's GAHH info
   */
  updateOrder: async (orderId: number, gahhOrderNumber: string, gahhInvoiceNumber: string): Promise<void> => {
    await client.put(`/netsuite-invoicing/orders/${orderId}`, {
      gahhOrderNumber,
      gahhInvoiceNumber
    });
  }
};
